<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="Close"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

<!--        <a-form-item-->
<!--          :labelCol="labelCol"-->
<!--          :wrapperCol="wrapperCol"-->
<!--          label="Order status">-->
<!--          <a-select style='width: 190px' v-model='queryParam.type'>-->
<!--            <a-select-option v-for='item in repayPlan' :key='item'>-->
<!--              {{ item.period }}-->
<!--            </a-select-option>-->
<!--          </a-select>-->
<!--        </a-form-item>-->

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Period Count">
          <a-checkbox-group  v-decorator="[ 'orderPeriod']" @change="checkBoxChange">
            <a-checkbox v-for="expression in repayPlan" :value="expression.period" v-if='expression.status == 0'>{{ expression.period }}</a-checkbox>
          </a-checkbox-group>
<!--          <a-select style='width: 190px' v-decorator="[ 'orderPeriod']">-->
<!--            <a-select-option v-for='item in repayPlan' :key='item'>-->
<!--              {{ item.period }}-->
<!--            </a-select-option>-->
<!--          </a-select>-->
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="SettledStatus">
          <dict-select
            v-decorator="[ 'settleStatus']"
            :dict-code="DICT_CODE.SETTLE_STATUS"
            :begin="[{ value: '', label: 'All', labelEn: 'All' }]"
            :placeholder="$t('select')"
          />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Total Repayment Amount">
          <a-input placeholder="Fill only takes effect, will override principal and clear zero other fees" v-decorator="[ 'totalRepayAmount']"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Due Date">
          <a-date-picker
            style="width: 100%"
            valueFormat="YYYY-MM-DD"
            placeholder="Fill only takes effect, directly override endDate"
            v-decorator="[ 'endDate']"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Interest">
          <a-input placeholder="Please enterInterest" v-decorator="[ 'interest']"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Deduction Amount">
          <a-input placeholder="Please enterDeduction Amount" v-decorator="[ 'deductionFee']"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="OverdueStatus">
          <dict-select
            v-decorator="[ 'overdueStatus']"
            :dict-code="DICT_CODE.OVERDUE_STATUS"
            :begin="[{ value: '', label: 'All', labelEn: 'All' }]"
            :placeholder="$t('select')"
          />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Overdue Days">
          <a-input placeholder="Please enterOverdue Days" v-decorator="[ 'overdueDays']"/>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'
import { editInstallmentOrderStatusForTest } from '@/webpublicapi/order'
import DictSelect from '../../modules/DictSelect';


// duplicateCheck
export default {
  name: 'TestInstallOrderModal',
  components: {
    DictSelect,
  },
  data () {
    return {
      value: 1,
      title: 'Action',
      visible: false,
      repayPlan: [],
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
    }
  },
  created () {
  },
  methods: {
    checkBoxChange(checkedValue) {
      console.log(checkedValue)
    },
    add () {
      this.edit({})
    },
    edit (record) {
      if (record.id) {
        this.visiblekey = true
      } else {
        this.visiblekey = false
      }
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.repayPlan = record.repayPlans;
        this.model.approvalStatus=String(this.model.approvalStatus)
        this.model.loanStatus=String(this.model.loanStatus)
        // this.model.overdueStatus=String(this.model.overdueStatus)
        this.model.settleStatus=String(this.model.settleStatus)
        this.form.setFieldsValue(pick(this.model,  'approvalStatus', 'loanStatus','settleStatus','applyAmt','interest', 'overdueStatus', 'deductionFee', 'orderPeriod', 'overdueDays'))
      })
    },
    // Confirm
    handleOk () {
      const that = this
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          const formData = Object.assign(this.model, values)
          let obj
          console.log(formData)
          obj = editInstallmentOrderStatusForTest(formData)
          obj.then((res) => {
            if (res.code === 1000) {
              this.$message.success(res.msg)
              this.$emit('ok')
            } else {
              this.$message.warning(res.msg)
            }
          }).finally(() => {
            this.confirmLoading = false
            this.close()
          })
        }
      })
    },
    // Close
    handleCancel () {
      this.close()
    },
    close () {
      this.$emit('close')
      this.visible = false
    }
  }
}
</script>
